import { useGameStore } from '../../store/gameSlice';
import './FloorIndicator.scss';

export const FloorIndicator = () => {
  const currentFloor = useGameStore((s) => s.currentFloor);

  return <div className="floor-indicator">Étage {currentFloor}</div>;
};
